import { gql } from '@apollo/client';

export const UPDATE_VORLAGE_STATION = gql`
  mutation mitarbeiter_updateVorlageStation(
    $input: mitarbeiter_updateVorlageStationInput!
  ) {
    mitarbeiter_updateVorlageStation(updateVorlageStationInput: $input) {
      success {
        vorlageStation {
          id
        }
      }
      error {
        message
      }
    }
  }
`;
